const mediaItems = [
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20an%20interview%20scene%20with%20warm%20dramatic%20lighting%20crimson%20and%20amber%20tones%20silhouetted%20figures%20in%20conversation%20mysterious%20atmosphere%20editorial%20style%20sophisticated%20composition&width=800&height=450&seq=media-01&orientation=landscape',
    title: '独家专访：圈内人揭秘综艺潜规则',
    duration: '32:18',
    tag: '独家',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20showing%20a%20collapsing%20timeline%20with%20warm%20red%20and%20gold%20gradients%20dramatic%20motion%20effect%20representing%20celebrity%20downfall%20tracing%20sophisticated%20art%20style&width=800&height=450&seq=media-02&orientation=landscape',
    title: '深度解析：顶流塌房时间线全复盘',
    duration: '45:06',
    tag: '深度',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20backstage%20music%20festival%20scene%20with%20warm%20golden%20lighting%20dramatic%20shadows%20abstract%20crowd%20and%20performers%20mysterious%20atmosphere%20sophisticated%20editorial%20style&width=800&height=450&seq=media-03&orientation=landscape',
    title: '现场直击：音乐节后台真实生态',
    duration: '28:54',
    tag: '现场',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">视频深扒</h2>
          <p className="mt-2 text-sm text-foreground-500">用影像还原事件真相</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-xs bg-background-950/60 text-background-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </span>
                {item.tag && (
                  <span className="absolute top-3 left-3 text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}